<app-kontable title = "{{ 'stateList.sectionTitle' | translate }}"
              [columns] = "['id', 'code', 'name', 'description', 'country_name']"
              [titles] = "['common.id', 'common.code', 'common.name', 'common.description', 'common.country_name']"
              [showInfoButton]="false"
              [showRecoverButton]="true"
              [showGlobalFilter]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [paginationType]="paginationType"
              [service]="srvState"
              (onAdd)="showAddOrEditDialog($event)"
              (onEdit)="showAddOrEditDialog($event)"
              (onRemove)="delete($event)"
              (onRecover)="recoverState($event)"
              [(fireNewDataAvailable)]="newDataAvailable"
></app-kontable>

<p-dialog *ngIf="showDetail"
          [width]="500"
          [(visible)]="showDetail"
          [responsive]="true"
          header="{{modalTitle}}"
          [modal]="true"
          (onHide)="onDialogHide()">

    <app-kv-state-form
                  [dialogBoxState]="srvState.stateEditing"
                  *ngIf="srvState.stateEditing"
                  (stateAdded)="stateAdded($event)"
                  (stateUpdated)="stateUpdated($event)">
    </app-kv-state-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/state/state.component.html